export default function SolverIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 4.5h-4.1C8.5 4.5 6.55 5.72 6.55 7.55c0 1.94 1.95 2.45 3.45 2.45s3.45.51 3.45 2.45c0 1.83-1.95 3.05-4.85 3.05H4.5"
        stroke="currentColor"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
